<template>
  <div
    :id="content.idHTML"
    :class="[
      jel_getClassObject(content),
      content.isPaddingDynamique === 'true' ? 'padding-dynamique' : 'w-100',
    ]"
  >
    <EditableArea
      v-if="content.blocEditable"
      :content="content.blocEditable"
      :parentTemplateId="metadata['mgnl:template']"
    >
    </EditableArea>
  </div>
</template>

<script>
import { EditableArea } from '@/vue-editor';

export default {
  name: 'BlocEditable',
  components: { EditableArea },
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  computed: {
    choixPadding() {
      if (this.content.justifie == 'start') return '';
      if (this.content.justifie == 'end') return 'float-right';
      return 'm-auto';
    },
  },
};
</script>
